package com.essntl.features.invoice.ui.addeditinvoice.components.content.extraservice

import androidx.compose.runtime.Composable
import com.essntl.features.service.ui.addextraservice.AddExtraServiceEvent
import com.essntl.features.service.ui.addextraservice.AddExtraServiceFormValidation
import com.essntl.features.service.ui.addextraservice.AddExtraServiceScreen
import com.essntl.features.service.ui.addextraservice.AddExtraServiceState
import com.essntl.uikit.components.dialog.EsDialog

@Composable
fun AddExtraServiceDialog(
    state: AddExtraServiceState,
    onEvent: (AddExtraServiceEvent) -> Unit,
    validation: AddExtraServiceFormValidation,
    isAddExtraServiceDialogOpened: Boolean,
    onDismissRequest: () -> Unit,
) {
    if (!isAddExtraServiceDialogOpened)
        return

    EsDialog(
        title = "Extra service",
        onDismissRequest = onDismissRequest,
    ) {
        AddExtraServiceScreen(
            state = state,
            onEvent = onEvent,
            validation = validation,
        )
    }
}